<template>
  <div v-if="!isLoading && list.length">
    <div class="d-flex justify-content-between flex-column">
      <Table style="margin-top: 1rem;" class="leads-table">
        <TableHeader>
          <TableRow>
            <TableHead
              v-for="(leadsCol, index) in leadsColumns"
              :key="`${leadsCol}-${index}`"
            >
              <ColumnHeader
                :sort="leadsCol.sort"
                :somatory="leadsCol.somatory"
                :columnName="leadsCol.name"
                :columnKey="leadsCol.key"
                :columnType="leadsCol.columnType"
                :currentColumnFiltered="currentColumnFiltered"
                :sortDirection="sortDirection"
                :dataList="list"
                @sortListByKey="sortListByKey(leadsCol.key)"
              />
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          <TableRow v-for="(item, idx) in list" :key="`${item}-${idx}`">
            <TableCell style="min-width: 45px;">{{ idx + 1 }}</TableCell>
            <TableCell style="min-width: 355px;"
              ><RenderNameColumnValue :name="item.name"
            /></TableCell>
            <TableCell
              ><RenderNameColumnValue
                :name="item.primaryCNAECode + '-' + item.primaryCNAEDescription"
            /></TableCell>
            <TableCell>{{ item.state }}</TableCell>
            <TableCell
              ><RenderNameColumnValue
                :name="item.cityCode + '-' + item.cityDescription"
            /></TableCell>
            <TableCell>
              <div
                style="display: flex; justify-content: space-between; align-items: center; width: 200px;"
              >
                <RenderSocialNumberColumnValue
                  :social-number="item.socialNumber"
                />
                <b-button
                  variant="outline-primary"
                  size="sm"
                  @click="copySocialNumber(item.socialNumber)"
                >
                  <b-icon-clipboard></b-icon-clipboard>
                </b-button>
              </div>
            </TableCell>
            <TableCell>
              {{ item.responsibleUserName }}
            </TableCell>
            <TableCell>
              <RenderDateColumnValue :value="item.creationDate" />
            </TableCell>
            <TableCell>
              {{ item.isExtracted ? 'Sim' : 'Não' }}
            </TableCell>
            <TableCell>
              {{ item.UCNumber }}
            </TableCell>
            <TableCell>
              {{ item.holderName }}
            </TableCell>
            <TableCell>
              {{ sceePowerMapping[item.hasSCEEPower] || 'Desconhecido' }}
            </TableCell>
            <TableCell>
              {{ item.hasLateBill ? 'Sim' : 'Não' }}
            </TableCell>
            <TableCell>
              {{ item.kwhTotalConsumption }}
            </TableCell>
            <TableCell>
              {{ item.numberOfActiveUCs }}
            </TableCell>
            <TableCell>
              <RenderPhoneColumnValue :phoneNumber="item.phonePCFA" />
            </TableCell>
            <TableCell>
              {{ item.emailPCFA }}
            </TableCell>
            <TableCell>
              {{ item.observation }}
            </TableCell>
            <TableCell>
              <b-overlay
                :show="busy"
                rounded
                opacity="0.6"
                spinner-small
                spinner-variant="secondary"
                class="d-inline-block"
              >
                <BaseButtonComponent
                  size="sm"
                  variant="primary-action"
                  @click="openLeadDetailsDialog(item)"
                >
                  Editar informações
                </BaseButtonComponent>
              </b-overlay>
            </TableCell>
            <TableCell>
              <b-overlay
                :show="busy"
                rounded
                opacity="0.6"
                spinner-small
                spinner-variant="secondary"
                class="d-inline-block"
              >
                <BaseButtonComponent
                  size="sm"
                  variant="primary-action"
                  @click="openUploadImageDialog(item)"
                >
                  Ver/Enviar imagens
                </BaseButtonComponent>
              </b-overlay>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
    <EditLeadDetailsModal
      ref="editLeadDetailsModalRef"
      @updateLeadInTable="updateLeadInTable"
    />
    <UploadImageModal
      ref="uploadImageModalRef"
      @handleUploadedImages="handleUploadedImages"
    />
  </div>
</template>

<script>
import {
  RenderSocialNumberColumnValue,
  RenderDateColumnValue,
  RenderNameColumnValue,
  RenderPhoneColumnValue,
} from '../../../../ui/render';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../../../ui/table';
import { QualificationSelect } from '../index.js';
import { defineArrowDirection, sortByProperty } from '../../../../utils';
import { ColumnHeader } from '../../../../ui/column-header';
import { Api } from '../../../../vue/api';
import { BaseButtonComponent } from '../../../../ui/buttons';
import EditLeadDetailsModal from '../modals/edit-lead-details-modal.vue';
import UploadImageModal from '../../../../ui/modals/upload-image-modal.vue';
const API = new Api();

export default {
  components: {
    Table,
    TableRow,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    ColumnHeader,
    QualificationSelect,
    RenderNameColumnValue,
    RenderDateColumnValue,
    RenderSocialNumberColumnValue,
    BaseButtonComponent,
    EditLeadDetailsModal,
    RenderPhoneColumnValue,
    UploadImageModal,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      leadsColumns: [
        { name: 'Nº', key: '', sort: false, somatory: false },
        { name: 'Razão Social/Nome', key: 'name', sort: true, somatory: false },
        {
          name: 'CNAE Primário',
          key: 'primaryCNAE',
          sort: true,
          somatory: false,
        },
        { name: 'UF', key: 'state', sort: true, somatory: false },
        { name: 'Município', key: 'city', sort: true, somatory: false },
        { name: 'CNPJ/CPF', key: 'socialNumber', sort: false, somatory: false },
        {
          name: 'Responsável',
          key: 'responsibleUserName',
          sort: true,
          somatory: false,
        },
        {
          name: 'Data feita',
          key: 'creationDate',
          sort: true,
          somatory: false,
        },
        {
          name: 'Foi extraído?',
          key: 'isExtracted',
          sort: false,
          somatory: false,
        },
        { name: 'Número UC', key: 'UCNumber', sort: false, somatory: false },
        {
          name: 'Nome Titular',
          key: 'holderName',
          sort: false,
          somatory: false,
        },
        {
          name: 'Já recebe energia SCEE?',
          key: 'hasSCEEPower',
          sort: false,
          somatory: false,
        },
        {
          name: 'Tem fatura atrasada?',
          key: 'hasLateBill',
          sort: false,
          somatory: false,
        },
        {
          name: 'Qual consumo total KWH?',
          key: 'kwhTotalConsumption',
          sort: false,
          somatory: false,
        },
        {
          name: 'Tem quantas UCs ativas?',
          key: 'numberOfActiveUCs',
          sort: false,
          somatory: false,
        },
        {
          name: 'Telefone PCFA',
          key: 'phonePCFA',
          sort: false,
          somatory: false,
        },
        { name: 'Email PCFA', key: 'emailPCFA', sort: false, somatory: false },
        {
          name: 'Observações',
          key: 'observation',
          sort: false,
          somatory: false,
        },
      ],
      sceePowerMapping: {
        '0': 'Não',
        '1': 'Sim - Isenta sem saldo',
        '2': 'Sim - S/ICMS sem saldo',
      },
      currentColumnFiltered: '',
      sortDirection: 'ASC',
      busyButton: false,
      busy: false,
      currentLeadToUploadImage: null,
    };
  },
  methods: {
    async handleUploadedImages(imageLinks) {
      if (!imageLinks) return;
      try {
        const { model, ok, errors } = await API.post('/execute', {
          path: '/lead-management/qualified-leads/image-links',
          method: 'post',
          data: {
            leadId: this.currentLeadToUploadImage,
            imageLinks: imageLinks,
          },
        });

        if (!ok) {
          throw new Error(errors.message || 'Falha ao salvar imagens no lead');
        }

        const leadFound = this.list.find(lead => lead.id === model.id);
        if (leadFound) {
          this.$set(leadFound, 'imageLinks', model.image_links);
        }

        this.showToast('Imagens salvas com sucesso!', 'Sucesso', 'success');
      } catch (err) {
        this.showToast(err.message, 'Erro', 'danger');
      }
    },
    showToast(message, title = 'Aviso', variant = 'info') {
      this.$bvToast.toast(message, { title, variant, solid: true });
    },
    copySocialNumber(socialNumber) {
      if (!socialNumber) {
        this.showToast('Não há número para copiar.', 'Aviso', 'warning');
        return;
      }
      navigator.clipboard
        .writeText(socialNumber)
        .then(() => {
          this.showToast('Número copiado com sucesso!', 'Sucesso', 'success');
        })
        .catch(err => {
          this.showToast(
            `Erro ao copiar número: ${err.message}`,
            'Erro',
            'danger',
          );
        });
    },
    sortListByKey(columnKey) {
      this.sortDirection = defineArrowDirection(
        this.currentColumnFiltered,
        columnKey,
        this.sortDirection,
      );
      this.currentColumnFiltered = columnKey;
      sortByProperty(this.list, columnKey, this.sortDirection);
    },
    openLeadDetailsDialog(lead) {
      this.$refs.editLeadDetailsModalRef.openModal({
        id: lead.id,
        UCNumber: lead.UCNumber,
        holderName: lead.holderName,
        hasSCEEPower: lead.hasSCEEPower,
        hasLateBill: lead.hasLateBill,
        kwhTotalConsumption: lead.kwhTotalConsumption,
        numberOfActiveUCs: lead.numberOfActiveUCs,
        phonePCFA: lead.phonePCFA,
        emailPCFA: lead.emailPCFA,
        observation: lead.observation,
      });
    },
    openUploadImageDialog(lead) {
      this.currentLeadToUploadImage = lead.id;
      var imageLinks = [];

      if (lead.imageLinks && lead.imageLinks.length) {
        imageLinks = JSON.parse(lead.imageLinks);
      }
      this.$refs.uploadImageModalRef.openModal(imageLinks);
    },
    updateLeadInTable(updatedLead) {
      const leadFound = this.list.find(lead => lead.id === updatedLead.id);
      if (leadFound) {
        this.$set(leadFound, 'UCNumber', updatedLead.uc_number);
        this.$set(leadFound, 'holderName', updatedLead.holder_name);
        this.$set(leadFound, 'hasSCEEPower', updatedLead.has_scee_power);
        this.$set(leadFound, 'hasLateBill', updatedLead.has_late_bill);
        this.$set(
          leadFound,
          'kwhTotalConsumption',
          updatedLead.kwh_total_consumption,
        );
        this.$set(
          leadFound,
          'numberOfActiveUCs',
          updatedLead.number_of_active_ucs,
        );
        this.$set(leadFound, 'phonePCFA', updatedLead.phone_pcfa);
        this.$set(leadFound, 'emailPCFA', updatedLead.email_pcfa);
        this.$set(leadFound, 'observation', updatedLead.observation);
        this.$set(leadFound, 'creationDate', updatedLead.created_at);
        this.$set(leadFound, 'isExtracted', updatedLead.is_extracted);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.leads-table {
  display: block;
  max-height: 48vh !important;
  height: auto !important;

  th:first-child,
  td:first-child {
    z-index: 2;
    position: sticky;
    left: 0;
    background-color: #e7e7e7;
  }

  td:nth-child(2),
  th:nth-child(2) {
    z-index: 2;
    position: sticky;
    left: 2.75rem;
    background-color: #e7e7e7;
  }

  td:nth-child(3),
  th:nth-child(3),
  td:nth-child(4),
  th:nth-child(4),
  td:nth-child(5),
  th:nth-child(5),
  td:nth-child(6),
  th:nth-child(6) {
    background-color: #e7e7e7;
  }

  tr:nth-child(odd) td:nth-child(-n + 6) {
    background-color: #e7e7e7;
  }
  tr:nth-child(even) td:nth-child(-n + 6) {
    background-color: #f2f2f2;
  }
}
</style>
